import { render, staticRenderFns } from "./Give_Gifts.vue?vue&type=template&id=93accc2c&scoped=true"
import script from "./Give_Gifts.vue?vue&type=script&lang=js"
export * from "./Give_Gifts.vue?vue&type=script&lang=js"
import style0 from "./Give_Gifts.vue?vue&type=style&index=0&id=93accc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93accc2c",
  null
  
)

export default component.exports